// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3vQpE","label":"Section_label__34dCY","contentWrap":"Section_contentWrap__V38MI","footer":"Section_footer__1UCx4","footerInner":"Section_footerInner__2DFN-"};